export default __webpack_public_path__ + "static/media/money-back@3x.e6c502d5.png";